@let commonData = commonDataService.getData() | async;

<a class="learn-more" target="_blank" [href]="commonData?.url + '/protection-plans'">
  <div class="d-flex g-1">
    <p class="caption semi-bold">Learn more</p>
    <img height="16" width="16" src="assets/icons/arrow_outward.svg" alt="arrow outward" />
  </div>
</a>
